import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faKey, faPlus, faUpload } from '@fortawesome/free-solid-svg-icons';
import * as S from './styles';
import { ChavesModalProps } from '../../../../pages/Cadastros/Empresas/types';
import { Modal } from '../../../interface/Modal';

const ChavesModal: React.FC<ChavesModalProps> = ({
  isOpen,
  onClose,
  empresa,
  chaves,
  chaveGerada,
  propagar,
  setPropagar,
  handleGerarChave,
  handleRevogarChave,
  handlePropagarChave,
}) => {
  if (!isOpen || !empresa) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`Chaves de ${empresa.nome || empresa.identificador}`}
      headerIcon={faKey}
      size="large"
    >
      <S.Conteudo>
        <S.Explicacao>
          São as chaves que o <strong>ERP desta empresa usa para consultar a API
          de Entregas</strong> — não confundir com a chave da listagem, que é a
          que o Entregas usa para consultar o ERP.
          <br />
          Ao gerar uma nova, marque <strong>gravar no ERP</strong> para que ela já
          entre em uso lá. Se o ERP estiver com uma chave diferente da que está
          aqui, use <strong>gravar no ERP</strong> na linha da chave certa — não
          precisa gerar outra.
        </S.Explicacao>

        {chaveGerada && (
          <S.ChaveGeradaBox $erro={!chaveGerada.propagada}>
            <S.Atencao>
              Copie a chave agora — ela não será exibida de novo.
            </S.Atencao>
            <S.ChaveValor>{chaveGerada.tokenaplicacao}</S.ChaveValor>
            {chaveGerada.propagada ? (
              <S.Atencao>Já gravada no ERP desta empresa.</S.Atencao>
            ) : (
              <S.AtencaoErro>
                Não foi possível gravá-la no ERP
                {chaveGerada.erroPropagacao
                  ? `: ${chaveGerada.erroPropagacao}`
                  : '.'}
              </S.AtencaoErro>
            )}
          </S.ChaveGeradaBox>
        )}

        {chaves.length === 0 ? (
          <S.Vazio>Esta empresa ainda não tem nenhuma chave.</S.Vazio>
        ) : (
          <S.Tabela>
            <thead>
              <tr>
                <th>Nome</th>
                <th>Chave</th>
                <th>Permissão</th>
                <th>Sessões</th>
                <th style={{ width: '190px' }} />
              </tr>
            </thead>
            <tbody>
              {chaves.map((chave) => (
                <tr key={chave.codigoaplicacao}>
                  <td>{chave.nomeaplicacao}</td>
                  <td>
                    <S.Mono>{chave.tokenaplicacao}</S.Mono>
                  </td>
                  <td>{chave.permissao}</td>
                  <td>{chave.tokens_ativos}</td>
                  <td>
                    <S.AcoesLinha>
                      <S.PropagarButton
                        type="button"
                        onClick={() => handlePropagarChave(chave)}
                        title="Gravar esta chave no ERP desta empresa"
                      >
                        <FontAwesomeIcon icon={faUpload} />
                        Gravar no ERP
                      </S.PropagarButton>
                      <S.RevogarButton
                        type="button"
                        onClick={() => handleRevogarChave(chave)}
                        disabled={chave.tokens_ativos > 0}
                        title={
                          chave.tokens_ativos > 0
                            ? 'Há sessões de usuário usando esta chave; revogá-la derrubaria essas sessões'
                            : 'Revogar esta chave'
                        }
                      >
                        Revogar
                      </S.RevogarButton>
                    </S.AcoesLinha>
                  </td>
                </tr>
              ))}
            </tbody>
          </S.Tabela>
        )}

        <S.Rodape>
          <S.CheckboxLinha htmlFor="propagar">
            <input
              id="propagar"
              type="checkbox"
              checked={propagar}
              onChange={(e) => setPropagar(e.target.checked)}
            />
            Gravar a chave nova no ERP desta empresa
          </S.CheckboxLinha>

          <S.GerarButton type="button" onClick={handleGerarChave}>
            <FontAwesomeIcon icon={faPlus} />
            Gerar chave
          </S.GerarButton>
        </S.Rodape>
      </S.Conteudo>
    </Modal>
  );
};

export default ChavesModal;
